export const SITE = {
  brand: "黑料大赛",
  slogan: "自黑无敌，笑到最后",
  intro:
    "黑料大赛是一场以「自黑」为主线的线上趣味赛事。我们把镜头对准你自己——那些翻车现场、社死瞬间、笑到拍桌的糗事，都是这方舞台上最亮的“黑料”。",
  email: "hello@heiliao-dasai.com",
  wechat: "heiliao-dasai",
  season: "2026 春季赛季",
};

export const navLinks = [
  { id: "home", label: "首页" },
  { id: "about", label: "赛事简介" },
  { id: "play", label: "玩法流程" },
  { id: "rules", label: "赛制规则" },
  { id: "eligible", label: "参赛条件" },
  { id: "judge", label: "评选标准" },
  { id: "tracks", label: "赛道分类" },
  { id: "stories", label: "往期精选" },
  { id: "faq", label: "常见问题" },
  { id: "contact", label: "联系我们" },
];

export const stats = [
  { value: "12.6 万", label: "累计参赛作品" },
  { value: "5 条", label: "独立赛道" },
  { value: "48 位", label: "专业评委" },
  { value: "03.01", label: "春季赛季开赛" },
];

export const values = [
  {
    icon: "ri-emotion-laugh-line",
    title: "只黑自己，不黑别人",
    desc: "所有作品必须聚焦本人亲身经历。我们拒绝任何针对他人的爆料、攻击与隐私曝光，让笑声只属于你自己。",
  },
  {
    icon: "ri-shield-check-line",
    title: "真实才是最好笑",
    desc: "编出来的段子再顺，也比不过真翻车的现场感。评审优先认可真实细节，越具体越有共鸣。",
  },
  {
    icon: "ri-trophy-line",
    title: "全民都能上台",
    desc: "不看粉丝量、不看设备，只比谁的故事更让人笑出声。素人和老手在同一条起跑线上。",
  },
];

export const steps = [
  {
    step: "01",
    title: "注册并进入赛季",
    desc: "用邮箱或手机号注册赛事账号，进入当前赛季的报名通道，查看本期赛道与命题方向。",
    icon: "ri-user-add-line",
  },
  {
    step: "02",
    title: "选择赛道并创作",
    desc: "在五条赛道中任选一条，用文字、图文或短视频讲清一件真实发生过的糗事，时长与字数都有明确上限。",
    icon: "ri-quill-pen-line",
  },
  {
    step: "03",
    title: "提交作品等待初审",
    desc: "提交后进入 72 小时初审，系统与人工共同核验原创性与合规性，通过的作品自动进入展映池。",
    icon: "ri-upload-cloud-2-line",
  },
  {
    step: "04",
    title: "展映、投票与评分",
    desc: "作品公开展映并开放大众投票，同时由专业评委依据四个维度打分，两部分成绩按比例合成最终得分。",
    icon: "ri-bar-chart-2-line",
  },
  {
    step: "05",
    title: "榜单公布与颁奖",
    desc: "赛季末公布各赛道榜单与总榜，获奖者获得奖杯、纪念周边与下一赛季的评委席推荐资格。",
    icon: "ri-award-line",
  },
];

export const timeline = [
  { date: "3 月 1 日", title: "赛季开启", desc: "报名与作品提交通道同步开放" },
  { date: "3 月 1 - 25 日", title: "作品征集期", desc: "持续接收投稿，可修改未通过初审的作品" },
  { date: "3 月 26 - 31 日", title: "初审与展映", desc: "合规核验完成，作品分批上线展映池" },
  { date: "4 月 1 - 12 日", title: "投票与评审期", desc: "大众投票与专业评委打分同步进行" },
  { date: "4 月 15 日", title: "榜单公布", desc: "各赛道榜单与总榜正式发布" },
];

export const rules = [
  {
    title: "作品形式",
    items: [
      "文字：单篇不超过 800 字，需为完整叙事。",
      "图文：不超过 9 张配图，图片须为本人拍摄或已获授权。",
      "短视频：时长不超过 3 分钟，横竖屏均可。",
    ],
  },
  {
    title: "内容红线",
    items: [
      "仅限讲述本人亲身经历，不得虚构他人故事。",
      "不得出现他人真实姓名、联系方式、工作单位等隐私信息。",
      "不得包含侮辱、歧视、低俗或违法内容。",
    ],
  },
  {
    title: "提交与修改",
    items: [
      "每人每个赛季最多提交 3 份作品，可分别投稿不同赛道。",
      "初审未通过的作品可在征集期内修改并重新提交一次。",
      "提交后即授权赛事进行非商业展映与投票展示。",
    ],
  },
  {
    title: "评分与结果",
    items: [
      "最终成绩 = 专业评委评分 × 70% + 大众投票得分 × 30%。",
      "同一作品不可重复获奖，赛区间以首次提交时间为准。",
      "对结果有异议可在榜单公布后 7 天内提交复核申请。",
    ],
  },
];

export const eligibility = [
  { icon: "ri-calendar-check-line", text: "年满 16 周岁，具备独立提交作品的能力。" },
  { icon: "ri-file-user-line", text: "已注册赛事账号，且账号信息真实有效。" },
  { icon: "ri-copyright-line", text: "作品为本人原创且真实发生，未在其他赛事获奖。" },
  { icon: "ri-forbid-2-line", text: "内容不涉及他人隐私、攻击性信息或违法内容。" },
  { icon: "ri-time-line", text: "遵守作品时长与字数上限，格式符合提交要求。" },
  { icon: "ri-hand-heart-line", text: "认可以自黑为核心的赛事氛围，尊重其他参赛者。" },
];

export const judging = [
  {
    name: "搞笑程度",
    weight: 35,
    desc: "是否真的让人笑出声，包袱是否自然、有反转、有记忆点。",
    icon: "ri-emotion-happy-line",
  },
  {
    name: "真实感",
    weight: 25,
    desc: "细节是否具体可信，能否让人相信这是真实发生过的现场。",
    icon: "ri-fingerprint-line",
  },
  {
    name: "故事完整度",
    weight: 25,
    desc: "起因、经过、结果是否讲清楚，节奏是否顺畅不拖沓。",
    icon: "ri-book-open-line",
  },
  {
    name: "表达力",
    weight: 15,
    desc: "文字节奏、镜头语言或讲述方式是否有个人特色与感染力。",
    icon: "ri-mic-line",
  },
];

export const tracks = [
  {
    key: "daily",
    name: "日常翻车",
    desc: "生活里那些猝不及防的小型事故现场，买菜、通勤、做饭都可能是名场面。",
    count: "3.2 万件作品",
    icon: "ri-bus-2-line",
  },
  {
    key: "workplace",
    name: "职场社死",
    desc: "会议、面试、汇报、群发消息……职场里最想删掉重来的瞬间。",
    count: "2.7 万件作品",
    icon: "ri-briefcase-4-line",
  },
  {
    key: "campus",
    name: "校园名场面",
    desc: "上课、考试、宿舍、社团，青春里那些至今还想捂脸的往事。",
    count: "2.9 万件作品",
    icon: "ri-graduation-cap-line",
  },
  {
    key: "relationship",
    name: "情感迷惑行为",
    desc: "追求、表白、见家长、分手现场的离谱操作，主打一个诚实。",
    count: "2.4 万件作品",
    icon: "ri-heart-2-line",
  },
  {
    key: "social",
    name: "社交尴尬",
    desc: "认错人、叫错名字、强行接话，社交场上的每一次呼吸都值得记录。",
    count: "1.4 万件作品",
    icon: "ri-chat-smile-3-line",
  },
];

export const stories = [
  {
    title: "我把老板的咖啡当成了自己的，一口喝完才发现",
    track: "职场社死",
    author: "打工人小陈",
    votes: "4.8 万票",
    score: "92.4",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20person%20sheepishly%20holding%20an%20empty%20coffee%20cup%20in%20an%20office%20kitchen%2C%20warm%20coral%20and%20cream%20palette%2C%20soft%20geometric%20shapes%2C%20playful%20minimal%20poster%20style%2C%20no%20text%2C%20clean%20neutral%20background%2C%20lighthearted%20editorial%20illustration&width=800&height=450&seq=hl-story-01&orientation=landscape",
    excerpt: "早上九点半，我端着杯子第三次经过茶水间，顺手拿起了那杯还温热的拿铁……",
  },
  {
    title: "视频会议忘关麦，我把吐槽全过程播给了全组",
    track: "职场社死",
    author: "远程星人",
    votes: "5.6 万票",
    score: "94.1",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20an%20awkward%20video%20call%20moment%20with%20a%20cat%20walking%20across%20a%20desk%20and%20microphone%20icon%2C%20warm%20amber%20and%20olive%20tones%2C%20soft%20rounded%20shapes%2C%20playful%20minimal%20poster%20style%2C%20no%20text%2C%20light%20cream%20background%2C%20witty%20editorial%20illustration&width=800&height=450&seq=hl-story-02&orientation=landscape",
    excerpt: "我以为静音了。我甚至还对着屏幕说了一句“等会儿再听他讲”。",
  },
  {
    title: "生日蛋糕翻进地毯，全场安静了三秒",
    track: "情感迷惑行为",
    author: "阿幸",
    votes: "4.1 万票",
    score: "90.7",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20person%20laughing%20while%20holding%20an%20upside%20down%20birthday%20cake%20on%20a%20living%20room%20rug%2C%20warm%20terracotta%20and%20gold%20palette%2C%20soft%20geometric%20shapes%2C%20playful%20minimal%20poster%20aesthetic%2C%20no%20text%2C%20clean%20cream%20background%2C%20cheerful%20editorial%20illustration&width=800&height=450&seq=hl-story-03&orientation=landscape",
    excerpt: "蜡烛还在烧，蜡烛先到了地毯上。我端着空托盘，笑到自己先破防。",
  },
];

export const testimonials = [
  {
    name: "汤圆不圆",
    role: "2025 秋季赛季 总榜第 3",
    quote: "本来只是随手投稿吐槽自己，没想到评论区一半人在说“这不就是我”。原来翻车也能翻得这么热闹。",
  },
  {
    name: "老周",
    role: "连续两届参赛选手",
    quote: "最打动我的是规则很干净——只准黑自己。没有互撕，没有挂人，大家笑得都特别放心。",
  },
  {
    name: "小满",
    role: "校园名场面赛道 人气奖",
    quote: "从写稿到拍摄总共花了两个晚上。流程清晰，提交后很快就收到初审反馈，体验比想象中顺畅太多。",
  },
];

export const faqs = [
  {
    q: "黑料大赛是什么类型的比赛？",
    a: "黑料大赛是一场以自黑为主线的线上趣味赛事，参赛者用文字或短视频分享自己亲身经历的糗事、翻车和社死名场面，由专业评委与大众投票共同选出获奖作品。",
  },
  {
    q: "黑料大赛怎么报名参加？",
    a: "在赛季开放期内提交作品即视为报名。每人每个赛季最多提交 3 份作品，作品须为本人真实经历。",
  },
  {
    q: "参加黑料大赛需要满足哪些条件？",
    a: "年满 16 周岁、作品为本人原创真实经历、内容不涉及他人隐私与攻击性信息、单份作品时长不超过 3 分钟或文字不超过 800 字。",
  },
  {
    q: "黑料大赛的评选标准是什么？",
    a: "评委从搞笑程度、真实感、故事完整度和表达力四个维度打分，其中大众投票占最终成绩的 30%。",
  },
  {
    q: "参加黑料大赛需要缴纳费用吗？",
    a: "不需要。黑料大赛全程免费报名，任何以报名费、晋级费名义收费的行为均与官方无关。",
  },
  {
    q: "作品可以涉及其他人吗？",
    a: "不允许。作品必须聚焦本人经历，涉及他人隐私、真实姓名或攻击性内容一律不予通过审核。",
  },
];

export const footerNav = [
  {
    title: "赛事信息",
    links: [
      { id: "about", label: "赛事简介" },
      { id: "rules", label: "赛制规则" },
      { id: "judge", label: "评选标准" },
      { id: "eligible", label: "参赛条件" },
    ],
  },
  {
    title: "参赛指南",
    links: [
      { id: "play", label: "玩法流程" },
      { id: "tracks", label: "赛道分类" },
      { id: "stories", label: "往期精选" },
      { id: "faq", label: "常见问题" },
    ],
  },
];